import { Routes } from '@angular/router';
import { superAdminChildGuard, superAdminGuard } from './guards/super-admin.guard';
import { clientOnlyGuard } from './guards/client-only.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'ads-campaigns'
  },
  {
    path: 'admin',
    canActivate: [superAdminGuard],
    canActivateChild: [superAdminChildGuard],
    loadComponent: () => import('./components/admin/admin-shell/admin-shell.component').then(m => m.AdminShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./components/admin/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./components/admin/user-management/user-management').then(m => m.UserManagementComponent)
      },
      {
        path: 'wallet',
        loadComponent: () => import('./components/admin/admin-credits/admin-credits.component').then(m => m.AdminCreditsComponent)
      },
      {
        path: 'store',
        loadComponent: () => import('./components/admin/admin-store/admin-store.component').then(m => m.AdminStoreComponent)
      },
      {
        path: 'ai-pricing',
        loadComponent: () => import('./components/admin/admin-ai-pricing/admin-ai-pricing.component').then(m => m.AdminAiPricingComponent)
      }
    ]
  },
  {
    path: 'config',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/configurations/configurations').then(m => m.UserConfigurationsComponent)
  },
  {
    path: 'posts',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/generated-posts/generated-posts').then(m => m.GeneratedPostsComponent)
  },
  {
    path: 'copywriting/new',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/copywriting/copywriting-new.component').then(m => m.CopywritingNewComponent)
  },
  {
    path: 'copywriting/:id',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/copywriting/copywriting-detail.component').then(m => m.CopywritingDetailComponent)
  },
  {
    path: 'copywriting',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/copywriting/copywriting.component').then(m => m.CopywritingComponent)
  },
  {
    path: 'lead-generation',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/lead-generation/lead-generation.component').then(m => m.LeadGenerationComponent)
  },
  {
    path: 'whatsapp',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/whatsapp/whatsapp').then(m => m.WhatsappComponent)
  },
  {
    path: 'store',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/usage-dashboard/usage-dashboard').then(m => m.UsageDashboardComponent)
  },
  {
    path: 'wallet',
    redirectTo: 'store',
    pathMatch: 'full'
  },
  {
    path: 'usage',
    redirectTo: 'store',
    pathMatch: 'full'
  },
  {
    path: 'email',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/email-marketing/campaign-list/campaign-list.component').then(m => m.CampaignListComponent)
  },
  {
    path: 'crm',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/crm/crm.component').then(m => m.CrmComponent)
  },
  {
    path: 'clients',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/company-clients/company-clients.component').then(m => m.CompanyClientsComponent)
  },
  {
    path: 'insights',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/insights.component').then(m => m.InsightsComponent)
  },
  {
    path: 'trends',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/trends/trends').then(m => m.UserTrendsComponent),
  },
  {
    path: 'editor/new',
    loadComponent: () => import('./components/user/inpainting-editor/inpainting-editor').then(m => m.InpaintingEditorComponent),
  },
  {
    path: 'editor/:postId',
    loadComponent: () => import('./components/user/inpainting-editor/inpainting-editor').then(m => m.InpaintingEditorComponent),
  },
  {
    path: 'ads-campaigns/new',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/ads-campaigns/ads-campaign-new/ads-campaign-new').then(m => m.AdsCampaignNewComponent)
  },
  {
    path: 'ads-campaigns/:id',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/ads-campaigns/ads-campaign-detail/ads-campaign-detail').then(m => m.AdsCampaignDetailComponent)
  },
  {
    path: 'ads-campaigns',
    canActivate: [clientOnlyGuard],
    loadComponent: () => import('./components/user/ads-campaigns/ads-campaign-list/ads-campaign-list').then(m => m.AdsCampaignListComponent)
  },
  { path: '**', redirectTo: 'ads-campaigns' }
];
